import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Chip, Icon } from '@popmenu/common-ui';
import { Heart } from '@popmenu/web-icons';
import { makeStyles } from '../../../utils/withStyles';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: theme.spacing(3),
    color: theme.palette.text.primary,
    cursor: 'unset',
    fontSize: '1rem',
    lineHeight: '2rem',
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(3, 0.5),
    textTransform: 'none',
  },
  icon: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
    position: 'relative',
    top: '6px',
  },
}));

export const DishLikesButton = ({ popsCount }: { popsCount: number }) => {
  const classes = useStyles();

  return (
    <Chip
      className={classes.button}
      label={(
        <React.Fragment>
          <Icon className={classes.icon} icon={Heart} />
          <FormattedMessage
            id="dish_likes_button.likes_count"
            defaultMessage="{popsCount, plural, one {# like} other {# likes}}"
            values={{
              popsCount,
            }}
          />
        </React.Fragment>
      )}
      variant="outlined"
    />
  );
};
